import React, { useEffect, createElement } from 'react';
export function OrganizationSchema() {
  useEffect(() => {
    const id = 'vitality-org-schema';
    let script = document.getElementById(id) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = id;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Vitality Venture Fund',
      alternateName: 'Vitality Vida Partners, LLC',
      url: 'https://www.vitalityvf.com',
      logo: 'https://cdn.magicpatterns.com/uploads/rLCDkCKprcJW1NkEV2aCi1/Vitality_Logo_Circle.png',
      description: "Vitality is a venture fund investing in deep tech and hard tech solutions rooted in biomimicry, circular systems, and resilience. We fuel startups built on nature's 3.8 billion years of R&D.",
      foundingDate: '2024',
      founder: {
        '@type': 'Person',
        name: 'Natalya Wallin',
        jobTitle: 'GP & Managing Director'
      },
      sameAs: ['https://www.linkedin.com/company/vitality-vf/'],
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'natalya@vitalityvf.com',
        contactType: 'General Inquiry'
      },
      knowsAbout: ['Biomimicry', 'Venture Capital', 'Nature-Inspired Innovation', 'Regenerative Agriculture', 'Deep Tech', 'Hard Tech', 'Climate Tech']
    };
    script.textContent = JSON.stringify(schema);
    return () => {
      script?.remove();
    };
  }, []);
  return null;
}